
export const DEV_URL = 'http://localhost:3001/api';
export const PROD_URL = 'https://api.milesahead.team/api';

// Current base url used
export const BASE_URL = PROD_URL;

export const login = BASE_URL+'/login-with-saved-credentials';
export const register = BASE_URL+'/register';
export const getJobsAndProcesses = BASE_URL+'/get-jobs-and-processes';
export const createOpportunities = BASE_URL+'/create-opportunities';
export const getCreatedOpportunities = BASE_URL+'/get-created-opportunities';

export const getOpportunityTracking = BASE_URL+'/get-opportunity-tracking';
export const opportunityTracking = BASE_URL+'/opportunity-tracking';
export const opportunities = BASE_URL+'/opportunities';
export const recruit = BASE_URL+'/recruit';
export const getOpportunitiesNotifications = BASE_URL+'/get-created-opportunities-notifications';